import styled from '@emotion/styled/macro';
import { css } from '@emotion/react';

import { linkWithUnderlineHover } from 'styles/mixins';
import { breakpoints } from 'styles/basic';
import { Link } from 'react-router-dom';

interface SongSideBoxProps {
  color?: 'primary' | 'secondary' | undefined;
}
interface ItemTypeProps {
  itemType?: 'encore' | 'encore2' | 'opening' | 'intro' | 'instrumental';
}

const SongsListWrapper = styled.ol`
  margin: 0;
  padding: 0;
  list-style-type: none;
`;

const SongItem = styled.li<ItemTypeProps>`
  display: flex;
  flex-flow: column wrap;
  justify-content: stretch;
  margin-top: .1rem;
  margin-bottom: .1rem;
  padding: 1rem 2rem 1rem 0;
  border-radius: .5rem;

  &:nth-of-type(2n) {
    background: #d3dae9;
  }
  ${(props) => (props.itemType === 'encore' || props.itemType === 'encore2') && css`
    border: .2rem solid ${props.theme.color.blue};
    background: ${props.theme.color.blue};
    color: ${props.theme.colorMono.white};
    &:nth-of-type(2n) {
      background: ${props.theme.color.blue};
    }
  `};
  ${(props) => props.itemType === 'opening' && css`
    border: .2rem solid ${props.theme.colorMono.black};
  `};
  ${(props) => props.itemType === 'instrumental' && css`
    border: .2rem solid ${props.theme.mainColors.primary};
  `};

  @media (min-width: ${breakpoints.portraitTablet}) {
    flex-flow: row nowrap;
  }
`;

const SongNumber = styled.span`
  flex-shrink: 0;
  width: 3rem;
  margin-right: 1rem;
  text-align: right;

  @media (min-width: ${breakpoints.portraitTablet}) {
    width: 4rem;
  }
`;

const SongTitle = styled.span`
  position: relative;
`;

const SongName = styled.span`
  display: flex;

  span:nth-of-type(2) {
    display: block;
  }

  @media (min-width: ${breakpoints.portraitTablet}) {
    width: calc(100%);
  }
`;

const SongAlbumName = styled.span`
  margin-right: 1rem;
  font-weight: bold;
  color: ${(props) => props.theme.mainColors.primary};
  white-space: nowrap;

  @media (min-width: ${breakpoints.portraitTablet}) {
    &::after {
      content: '/';
      margin-left: 1rem;
    }
  }
`;

const SongNameLink = styled(Link)`
  display: block;
  ${(props) => linkWithUnderlineHover(SongTitle, 2, props.theme.mainColors.primary)};

  @media (min-width: ${breakpoints.portraitTablet}) {
    display: flex;
    align-items: baseline;
  }
`;

const SongSide = styled.span`
  display: flex;
  flex-shrink: 0;
  flex-direction: row-reverse;
  justify-content: left;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
  margin-left: 4rem;

  @media (min-width: ${breakpoints.portraitTablet}) {
    flex-direction: row;
    justify-content: right;
    margin-top: 0;
    margin-left: auto;
    text-align: right;
  }
`;

const SongSideBox = styled.span<SongSideBoxProps>`
  justify-content: right;
  text-align: center;

  &, a {
    display: flex;
    align-items: center;
  }

  @media (min-width: ${breakpoints.portraitTablet}) {
    width: 4rem;
  }

  ${(props) => props.color === 'primary' && css`
    color: ${props.theme.mainColors.primary};
  `};

  ${(props) => props.color === 'secondary' && css`
    color: ${props.theme.mainColors.secondary};
  `};
`;

const WiderSongSideBox = styled.span`
  justify-content: right;
  width: auto;
`;

const StyledInlineLink = styled(Link)`
  display: inline-block;
  ${(props) => linkWithUnderlineHover(SongTitle, 2, props.theme.mainColors.primary)};
`;

export {
  SongsListWrapper,
  SongItem,
  SongNumber,
  SongName,
  SongNameLink,
  SongTitle,
  SongAlbumName,
  SongSide,
  SongSideBox,
  WiderSongSideBox,
  StyledInlineLink
};
